<ion-content class="theme-{{userService.theme}}">
    <div class="content">
        <ion-header class="transparent">
            <app-header class="dark-mode"
                        [backRoute]="['/team']"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="true" [@enter]>
            </app-header>
        </ion-header>
        <div class="bg bg-inner-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform === 'mobile'}" [@enter]></div>
        <app-manager-panel *ngIf="true"></app-manager-panel>
        <div class="shadow-container" *ngIf="reports === null">
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
            <app-review-skeleton></app-review-skeleton>
        </div>

        <div class="shadow-container" *ngIf="reports !== null">
            <app-inline-svg style="position: absolute; top: .5rem; right: .5rem; width: 2.5rem; height: 2.5rem;" class='add-report-btn' (click)="goBack()" [file]="'assets/img/close.svg'"></app-inline-svg>
            <div class="shadow-container-description">
                <div class="font-header desc-header">{{delegate?.full_name}} <span style="font-weight: 300;">- {{'__REVIEW_REPORT_LIST_MANAGER_TITLE__' | translate}}</span></div>
                <div class="font-larger bordered">{{'__REVIEW_REPORT_LIST_MANAGER_CONTENT__' | translate}}</div>
            </div>
            <div class="table-header">
                <div style="text-align: left;">{{'__REVIEW_REPORT_LIST_HEADER_LINE_MANAGER__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_REVIEW_PERIOD__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_CREATED__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_LAST_SAVED__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_STATUS__' | translate}}</div>
                <div>{{'__REVIEW_REPORT_LIST_HEADER_PEER_REVIEW__' | translate}}</div>
            </div>
            <ng-container *ngFor="let report of reports">
                <div class="shadow-element" [routerLink]="report.type === 'review' ? ['/review/report/' + report.id] : ['/review/report/one2one/' + report.id]">
                    <div style="text-align: left;">{{report.manager?.full_name}}</div>
                    <div>{{report.type === 'review' ? report.period : '1 to 1 Meeting'}}</div>
                    <div>{{report.created_at.output.iso | amDateFormat : 'DD / MM / YY' }}</div>
                    <div>{{report.updated_at.output.iso | amDateFormat : 'DD / MM / YY'}}</div>
                    <div class="element-img status-img">
                        <img src="assets/img/{{report.status ? 'check-active.svg' : 'check-disable.svg'}}" alt="">
                    </div>
                    <div class="element-img">
                        <app-inline-svg
                            class='download-report-btn'
                            *ngIf="report.type === 'review'"
                            (click)="openModal($event, report)"
                            [ngClass]="{disabled: report.status}"
                            [file]="report.status ? 'assets/icon/users.svg' : 'assets/icon/users-active.svg'"></app-inline-svg>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!reports.length">
                <div class="shadow-element" style="text-align: left;"><div style="font-size: 1.5rem; color: grey;">{{'__REVIEW_REPORT_LIST_NO_ELEMENTS__' | translate}}</div></div>
            </ng-container>
            <ion-modal id="emailModal" #addRespondentModalRef [isOpen]="isModalOpen" [canDismiss]='true' (willDismiss)="onModalWillDismiss($event)">
                <ng-template>
                    <div class="modal-wrapper font-larger">
                        <img style="position: absolute; top: .5rem; right: .5rem; width: 2.5rem; height: 2.5rem;" (click)="modalCancel()" src="assets/img/close.svg">
                        <div class="modal-header font-large">
                            {{'__REVIEW_REPORT_LIST_RESPONDENT_MODAL_CONTENT__' | translate}} <b>{{currentReport.delegate.full_name}}</b>
                        </div>
                        <div class="modal-body">
                            <div class="input-block">
                                <form (ngSubmit)="searchUsers()">
                                <ion-input name="keywords" [(ngModel)]="keyword">
                                    <img src="assets/icon/search-green.svg" class="touch-eff-radius"
                                         *ngIf="!isUsersListLoading"
                                         (click)="searchUsers()">
                                    <ion-spinner *ngIf="isUsersListLoading"></ion-spinner>
                                </ion-input>
                                </form>
                                <div class="options">
                                    <ng-container *ngIf="isUsersListLoading">
                                        <div class="choice"><ion-skeleton-text style="height: 2rem; width: 60%" animated></ion-skeleton-text></div>
                                        <div class="choice"><ion-skeleton-text style="height: 2rem; width: 70%" animated></ion-skeleton-text></div>
                                        <div class="choice"><ion-skeleton-text style="height: 2rem; width: 50%" animated></ion-skeleton-text></div>
                                    </ng-container>
                                    <div class="choice" *ngFor="let user of usersList"
                                         (click)="pickUser(user)"
                                         [ngClass]="{active: currentUser && currentUser.id === user.id}"
                                    >{{user.email}}</div>
                                </div>
                            </div>
                            <div class="right-column">
                                <button (click)="addRespondent()" class="submit-btn font-larger touch-eff-radius" [disabled]="currentUser === null || isRespondentAdding">
                                    <ng-container *ngIf="!isRespondentAdding">{{'__REVIEW_REPORT_LIST_RESPONDENT_MODAL_SEND__' | translate}}</ng-container>
                                    <ion-spinner *ngIf="isRespondentAdding"></ion-spinner>
                                </button>
                                <div *ngIf="isRespondentAdded" class="done-block">
                                    <img src="assets/icon/done.svg" alt="" *ngIf="!isRespondentAdding">
                                    <div style="text-align: center;">{{'__REVIEW_REPORT_LIST_RESPONDENT_MODAL_EMAIL__' | translate}}<br><b>{{currentUser.email}}</b></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ion-modal>
        </div>
    </div>
</ion-content>
